import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 *资料列表
 * @param params
 * 
*/

export const annexList = params => Http.get(`${baseUrl}/course/annex`, { params })
